import * as styles from './container.module.sass';
import { IconText } from '../../molecules/IconText';
import classNames from 'classnames';
import React from 'react';
import { Size } from '../../enums/size';
import { Color } from '../../enums/color';

export const IconTextContainer = (props: any) => {
  const classProps: string = classNames(styles.text_icon_container, props.className);

  const text = props.iconWithText.map((item: any, key: any) => (
    <IconText
      key={key}
      size={Size.REGULAR}
      color={Color.DEFAULT}
      icon_background
      title={item.title}
      icon_name={`icon-${item.icon_name}`}
    />
  ));

  return <div className={classProps}>{text}</div>;
};
